import { Card, Col, Row, Tooltip } from 'antd';
import getSymbolFromCurrency from 'currency-symbol-map';
import get from 'lodash/get';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import { Link } from 'react-router-dom';
import WebIcon from 'src/_shared/components/WebIconComponent.jsx';
import { ImInterestedButton } from 'src/_shared/components/im-interested-send-button';
import { ShareSendButton } from 'src/_shared/components/share-send-button';
import { USER_ROLES } from 'src/_shared/constants';
import { JobLocation } from 'src/_shared/index.js';
import { ReferralModal } from 'src/_shared/referral-modal';
import { ReferralRequestModal } from 'src/_shared/referral-request-modal';
import { calculateReferralBonus, ml, formatBonusAmount, resolveActiveTieredBonus } from 'src/_shared/services/utils.js';
import { COLORS } from 'src/_shared/styles/colors';
import { companyNameText, jobMatch, jobMatchNumber } from './jobCardStyles.js';
import PayoutDaysDisplay from 'src/_shared/components/index.js';
import { GetJobByIdHiringManager } from './jobByIdHiringManagerGraphql';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween.js';
dayjs.extend(isBetween);

class JobCardComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			matches: null,
			theme: JSON.parse(get(props, 'currentUser.company.theme', '{}')),
			translatedTitle: '',
			hiringManager: null,
		};
	}

	async componentDidMount() {
		const { currentUser,job, jobMatches = [] } = this.props;
		const stateChanges = {};
		if (job?.jobType) {
			stateChanges.job = job;
		}
		if (job?.title) {
			stateChanges.translatedTitle = job.title;
		}

		if (job) {
			stateChanges.matches = jobMatches.filter(
				(jobMatch) =>
					jobMatch?.userId === currentUser?.id &&
					jobMatch?.relevance >= 30 &&
					jobMatch?.matchStatus !== false
			);
			if (currentUser?.company?.showRecruiterInfoJobCard) {
				await this.getHiringManagerDetails();
			}
		}
		this.setState(stateChanges);
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps?.job?.title !== this.props?.job?.title
		) {
			this.setState({
				translatedTitle: this.props?.job?.title,
			});
		}
	}

	async getHiringManagerDetails(policy = 'network-only') {
		const { client, job } = this.props;
		try {
			const jobId = get(job, 'id', null);
			if (jobId !== null) {
				const { data } = await client.query({
					query: GetJobByIdHiringManager,
					variables: {
						id: jobId,
					},
					fetchPolicy: policy,
				});
				const result = get(data, 'getJob', null);
				if (result.hiringManager) {
					this.setState({
						hiringManager: result.hiringManager,
					});
				}

			}
		} catch (error) {
			console.log(error);
		}
	}

	render() {
		const {
			allMultiLingualData,
			currentUser,
			onUpdateJob,
			onCreateReferral,
			contactIncentiveBonus,
			contacts,
			navLocation,
			allowSelfReferrals,
			contactsNextToken,
			currentCurrencyRate,
			currentCurrencySymbol,
			currentUserCompany,
			isExtendedUser,
			allowSelfReferralsInternalLink,
			onCreateUserJobShare,
			userJobShares,
			onUpdateUserJobShare,
			setUpdatedContacts,
			hideSubcompanyOnJobs,
			job = {},
		} = this.props;
		const {
			hiringManager,
			translatedTitle,
			loading,
			matches,
			theme,
		} = this.state;
		const {
			subCompanyId,
			subCompanyName = '',
			campaign,
			campaignId,
			isHotJob = false,
			publicLink: jobPublicLink,
			id,
			internalJobLink,
			title = '',
			department,
			departmentId,
			company,
			jobType,
			referrals = [],
			description = '',
			status,
			shares,
			tieredBonus,
			referralBonus,
			isGeneralReferral,
			hideImInterested,
		} = job;
		const extendedNetworkUsers = (currentUser?.extendedContactData || []).filter(user => user?.user?.companyId === job?.companyId);
		const location = job?.job?.location || {};
		const locations = job?.job?.locations || [];
		let isCampaignActive = false;
		if (!campaign?.archived && campaign?.startDate && campaign?.endDate) {
			const today = dayjs.utc();
			const startDate = dayjs.utc(campaign.startDate);
			const endDate = dayjs.utc(campaign.endDate);
			isCampaignActive = Boolean(today.isBetween(startDate, endDate, 'day', '[]'));
		}

		const currentTieredBonus = resolveActiveTieredBonus(
			job,
			currentUser?.userGroupId
		);
		const referredBy = currentUser?.id;
		const languageCode = (
			!currentUser?.languageCode
			|| currentUser?.languageCode === 'US'
		) ? 'EN' : currentUser.languageCode;

		const { origin } = window.location;
		const jobUrl = `${origin}/newreferral/${referredBy}/${id}/${languageCode}`;
		const publicLink = jobUrl;

		const companyId = company?.id;
		const userGroupCurrency = currentUser?.userGroup?.currency || 'USD';
		const disableReferrals = currentUser?.company?.disableReferrals ?? false;
		const getBonusAmount = (
			contactIncentiveBonus,
			referralBonusAmount,
			incentiveEligible,
			currentTieredBonus,
			employee,
			userGroupId
		) => {
			const bonusValue = calculateReferralBonus(
				contactIncentiveBonus,
				referralBonusAmount,
				incentiveEligible,
				currentTieredBonus,
				employee,
				userGroupId
			);
			return formatBonusAmount(getSymbolFromCurrency(userGroupCurrency), bonusValue);
		};

		const generalReferralJob = () => {
			return (
				<li>
					<Tooltip
						arrowPointAtCenter
						placement="topRight"
						title={ml(
							'General Jobs represent multiple openings. A new referral and bonus (if applicable) will be created when the candidate is moved to a different job.',
							currentUser,
							allMultiLingualData
						)}
					>
						<span className="general-job-tag">
							{ml('General Job', currentUser, allMultiLingualData)}
						</span>
					</Tooltip>
				</li>
			);
		};

		const hideInterestedForGroup = currentUser?.company?.hideInterestedForGroup;
		let filteredUserGroups = [];
		let isHideImInterestedForEmp = false;
		if (
			hideInterestedForGroup !== null &&
			hideInterestedForGroup !== undefined
		) {
			filteredUserGroups = JSON.parse(hideInterestedForGroup);
			const userGroupId = currentUser?.userGroup?.id;
			isHideImInterestedForEmp = filteredUserGroups.some(function (value) {
				return value.id === userGroupId;
			});
		}

		const hideShareLinkForDepartment = currentUserCompany?.hideShareLinkForDepartment;
		let hideDepartmentShareLink = false;
		if (hideShareLinkForDepartment) {
			const jsonData = JSON.parse(hideShareLinkForDepartment);
			hideDepartmentShareLink = jsonData.some(function (value) {
				return value.id === departmentId;
			});
		}

		const hideShareLinkNoPublicUrl = currentUserCompany?.hideShareLinkNoPublicUrl;

		const payoutDaysTiers = currentTieredBonus?.tiers || [];
		const campaignPayoutDaysTiers = campaign?.tieredBonus?.tiers || [];
		const tieredBonusName = tieredBonus?.name || '';

		const totalTags =
			(payoutDaysTiers?.length > 0 ? 1 : 0) +
			(campaignPayoutDaysTiers?.length > 0 ? 1 : 0);

		return (
			<Card
				bordered={false}
				bodyStyle={{ padding: 0, height: '100%' }}
				className="job-card"
				style={isHotJob ? { borderColor: '#f7a34d' } : {}}
			>
				<div className="job-card-inner">
					{!loading && (
						<div className="job-card-header">
							<div className="job-title-wrap">
								<h4 className="job-title">
									<Link
										to={{
											pathname: `/browsejobs/${id}`,
											state: {
												referrals,
												currentUserCompany,
											},
										}}
									>
										{translatedTitle}
									</Link>
								</h4>
								<ul className="actions">
									{isHotJob == true && (
										<li>
											<i className="icon-fire text-orange" />
										</li>
									)}

									{isGeneralReferral
										? generalReferralJob()
										: (referralBonus?.hasBonus || isCampaignActive) &&
											!isExtendedUser && (
												<li>
													<span className="amount">
														{getBonusAmount(
															contactIncentiveBonus,
															referralBonus?.amount,
															currentUser?.incentiveEligible,
															currentTieredBonus,
															'employee',
															currentUser?.userGroupId
														)}
													</span>
												</li>
											)}
								</ul>
							</div>

							{isExtendedUser && (
								<div className={companyNameText}>
									{job?.company?.name}
								</div>
							)}

							{!currentUserCompany?.hidePaymentInfoJobCard && (
								<div
									className="mb-4 d-flex"
									style={{ justifyContent: 'flex-end' }}
								>
									<PayoutDaysDisplay
										currentUser={currentUser}
										allMultiLingualData={allMultiLingualData}
										tiers={payoutDaysTiers}
										tieredBonusName={tieredBonusName}
										totalTags={totalTags}
									/>
								</div>
							)}

							<div className="job-info-wrap">
								<ul className="job-info">
									<JobLocation
										allMultiLingualData={allMultiLingualData}
										currentUser={currentUser}
										location={location}
										locations={locations}
									/>

									{!isExtendedUser && (
										<li>
											<i className="icon-folder" />
											<span>{department ? department.name : ''}</span>
										</li>
									)}
									{subCompanyId &&
										(!hideSubcompanyOnJobs ||
											currentUser?.role !== 'employee') && (
											<li>
												<i className="icon-building" />
												<span>{subCompanyName}</span>
											</li>
										)}
									{/* If company is ZT systems */}
									{companyId === 'e600195e-d1d9-4163-8b22-f0f250c4bcfd' &&
										job?.displayReqId !== true &&
										job?.displayReqId !== '' &&
										job?.displayReqId && (
											<li>
												{'ID#: '}
												{job?.displayReqId}
											</li>
										)}
									{companyId !== 'e600195e-d1d9-4163-8b22-f0f250c4bcfd' &&
										job?.externalJobId !== true &&
										job?.externalJobId !== '' &&
										job?.externalJobId && (
											<li>
												{'ID#: '}
												{job?.externalJobId}
											</li>
										)}
									{hiringManager && currentUser?.company?.showRecruiterInfoJobCard && (
										<li>
											{ml('Recruiter', currentUser, allMultiLingualData)}:
											<a
												href={`mailto:${hiringManager?.emailAddress}`}
												style={{marginLeft: '4px'}}
											>
												{`${hiringManager?.firstName} ${hiringManager?.lastName}`}
											</a>
										</li>
									)}
								</ul>
								{!currentUserCompany?.disableShareLink &&
									status === 'open' &&
									!isExtendedUser &&
									!hideDepartmentShareLink &&
									(!hideShareLinkNoPublicUrl ||
										(hideShareLinkNoPublicUrl && jobPublicLink)) && (
										<span className="share">
											<ShareSendButton
												iconOnly
												allMultiLingualData={allMultiLingualData}
												theme={theme}
												title={title}
												jobId={id}
												jobUrl={publicLink}
												company={company}
												jobType={jobType}
												description={description}
												city={location?.city || null}
												state={location?.state || null}
												shares={shares}
												referredBy={referredBy}
												languageCode={languageCode}
												currentUser={currentUser}
												userJobShares={userJobShares}
												onUpdateJob={onUpdateJob}
												onCreateUserJobShare={onCreateUserJobShare}
												onUpdateUserJobShare={onUpdateUserJobShare}
											/>
										</span>
									)}
							</div>

							{currentUserCompany?.disableSmartReferrals !== true &&
								matches?.length > 0 &&
								!isExtendedUser && (
									<Row type="flex" className={jobMatch}>
										<WebIcon
											name="tick-inside-circle"
											color={COLORS.green}
											size={14}
										/>
										<span className={jobMatchNumber}>{matches?.length}</span>{' '}
										Smart Referrals
									</Row>
								)}
						</div>
					)}

					{status === 'open' && (
						<div className="job-card-footer ateet">
							{isExtendedUser && (
								<Row gutter={5}>
									<Col span={24}>
										<div
											style={{
												textAlign: 'center',
												color: COLORS.lightGray4,
												height: 40,
												marginTop: 10,
												marginBottom: -10,
											}}
										>
											{ml(
												'You are connected to',
												currentUser,
												allMultiLingualData
											)}{' '}
											<strong style={{ color: COLORS.textSecondaryNeutral }}>
												{extendedNetworkUsers.length}
											</strong>{' '}
											{ml(`employee${extendedNetworkUsers.length === 1 ? '' : 's'}`, currentUser, allMultiLingualData)}
											.
										</div>
										<ReferralRequestModal
											allMultiLingualData={allMultiLingualData}
											extendedNetworkUsers={extendedNetworkUsers}
											contacts={contacts}
											test="test"
											job={job}
											referrals={referrals}
										/>
									</Col>
								</Row>
							)}
							{status === 'open' && !isExtendedUser && (
								<>
									<ReferralModal
										disabled={disableReferrals && !jobPublicLink}
										contacts={contacts}
										setUpdatedContacts={setUpdatedContacts}
										contactsNextToken={contactsNextToken}
										navLocation={navLocation}
										jobData={job}
										job={job}
										buttonType="large"
										isBtnBlock="true"
										referrals={referrals}
										currentCurrencyRate={currentCurrencyRate}
										currentCurrencySymbol={currentCurrencySymbol}
										contactIncentiveBonus={contactIncentiveBonus}
										campaignId={campaignId}
										test="test"
										onUpdateJob={onUpdateJob}
										onCreateUserJobShare={onCreateUserJobShare}
										onUpdateUserJobShare={onUpdateUserJobShare}
									/>

									{(currentUser?.role ===
										USER_ROLES.EMPLOYEE && isHideImInterestedForEmp)
										? null
										: allowSelfReferrals &&
											((allowSelfReferralsInternalLink && internalJobLink) ||
												!allowSelfReferralsInternalLink) && (
												<ImInterestedButton
													key={job.id}
													disabled={hideImInterested}
													allMultiLingualData={allMultiLingualData}
													contacts={contacts}
													currentUser={currentUser}
													internalJobLink={internalJobLink}
													job={job}
													onCreateReferral={onCreateReferral}
												/>
											)}
								</>
							)}
						</div>
					)}
				</div>
			</Card>
		);
	}
}

export default withApollo(JobCardComponent);
